module.exports = __webpack_public_path__ + "img/capsphere.2feebd3a.jpg";